module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pull-right"
  }, [(_vm.phases.length > 0 && _vm.phases[0].active != 1) ? _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.rollback
    }
  }, [_c('i', {
    staticClass: "fa fa-backward"
  }), _vm._v(" Rollback Phase")]) : _vm._e(), _vm._v(" "), (_vm.activePhaseIndex < _vm.phases.length && !_vm.allPhasesComplete) ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.advance
    }
  }, [_vm._v("Advance Phase "), _c('i', {
    staticClass: "fa fa-forward"
  })]) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('button', {
    staticClass: "btn btn-default pull-right",
    staticStyle: {
      "margin-left": "20px"
    },
    on: {
      "click": _vm.editPhases
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" Edit Phases")]) : _vm._e()]), _vm._v(" "), _c('h2', [_vm._v("Phases")]), _vm._v(" "), _c('ul', {
    staticClass: "phase-list"
  }, _vm._l((_vm.phases), function(phase, index) {
    return _c('li', {
      staticClass: "list-group-item",
      class: {
        'list-group-item-info': phase.active == 1,
          'list-group-item-success': phase.completed_at != null
      }
    }, [(phase.completed_at != null) ? _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("Completed at " + _vm._s(_vm.formatDate(phase.completed_at, 'long, minutes')))]) : (phase.active == 1) ? _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("In Progress")]) : _c('span', {
      staticClass: "pull-right"
    }, [_vm._v("Pending")]), _vm._v(" "), _c('h3', [_c('i', {
      staticClass: "fa",
      class: {
        'fa-check': phase.completed_at != null,
          'fa-ellipsis-h': phase.completed_at == null,
          'fa-play-circle': phase.active == 1
      }
    }), _vm._v(" \n\t\t\t\t\t" + _vm._s("label" in phase ? phase.label : phase.phases.label) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('label', {
      on: {
        "click": function($event) {}
      }
    }, [_vm._v("Notes "), _c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (phase.notes),
        expression: "phase.notes"
      }],
      staticClass: "form-control",
      attrs: {
        "readonly": (phase.completed_at != null)
      },
      domProps: {
        "value": (phase.notes)
      },
      on: {
        "change": function($event) {
          _vm.autoSaveNote(phase)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          phase.notes = $event.target.value
        }
      }
    })])
  })), _vm._v(" "), (_vm.phaseDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": "Project Phases",
      "modal-visible": _vm.phaseDialog.visible,
      "confirm-button-text": "Save",
      "button-class": "btn-success"
    },
    on: {
      "confirm": _vm.updateProjectPhases,
      "closeModal": function($event) {
        _vm.phaseDialog.visible = false
      }
    }
  }, [(_vm.masterPhases.length > 0) ? _c('div', [_c('p', [_vm._v("Select the phases that this project should progress through:")]), _vm._v(" "), _vm._l((_vm.masterPhases), function(phase) {
    return _c('div', {
      key: phase.id,
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.phaseDialog.includedPhases),
        expression: "phaseDialog.includedPhases"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": phase.id,
        "checked": Array.isArray(_vm.phaseDialog.includedPhases) ? _vm._i(_vm.phaseDialog.includedPhases, phase.id) > -1 : (_vm.phaseDialog.includedPhases)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.phaseDialog.includedPhases,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = phase.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.phaseDialog.includedPhases = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.phaseDialog.includedPhases = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.phaseDialog.includedPhases = $$c
          }
        }
      }
    }), _vm._v("\n\t            \t\t" + _vm._s(phase.label) + "\n\t            \t")])])
  }), _vm._v(" "), _c('p', [_vm._v("Want to add more phases? Head over to the "), _c('router-link', {
    attrs: {
      "to": "/phases"
    }
  }, [_vm._v("Master Phase List")]), _vm._v(".")], 1)], 2) : _c('div', [_c('p', [_vm._v("Oops! You haven't created any phases yet. Go on over to the "), _c('router-link', {
    attrs: {
      "to": "/phases"
    }
  }, [_vm._v("Master Phase List")]), _vm._v(" to create some!")], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92928e8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhaseList.vue
// module id = 302
// module chunks = 0